// Télécharge un fichier protégé de l'API (export, modèle Excel…) avec son
// nom d'origine. getFile : () => Promise<{ blob, filename }> (cf. reqBlobFile).
export async function downloadProtectedFile(getFile) {
  try {
    const { blob, filename } = await getFile();
    const url = URL.createObjectURL(blob);
    Object.assign(document.createElement("a"), { href: url, download: filename }).click();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    window.alert(err?.message || "Téléchargement impossible.");
  }
}

// Ouvre dans un nouvel onglet un fichier protégé de l'API (PDF importé…).
//
// Un simple <a href="/api/..."> n'envoie PAS le jeton (en-tête
// Authorization) → l'API répond « Token d'authentification manquant ».
// On récupère donc le fichier via l'API (avec le jeton), puis on l'affiche.
//
// L'onglet est ouvert DÈS le clic, avant le téléchargement : ouvert après
// un await, il serait bloqué comme pop-up par Safari/Firefox.
export async function openBlobInNewTab(getBlob) {
  const tab = window.open("", "_blank");
  if (tab) tab.document.title = "Chargement…";
  try {
    const blob = await getBlob();
    const url = URL.createObjectURL(blob);
    if (tab) {
      tab.location.href = url;
    } else {
      // Pop-up bloquée malgré tout : téléchargement direct
      Object.assign(document.createElement("a"), { href: url, download: "document.pdf" }).click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    const message = err?.message || "Impossible d'ouvrir le document.";
    if (tab) {
      tab.document.body.style.cssText = "font-family:sans-serif;padding:24px;color:#b91c1c";
      tab.document.body.textContent = message;
    } else {
      window.alert(message);
    }
  }
}
